// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;Who gives justice to those that suffer wrong&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and bread to those who hunger.<br> </p> </div></div>";
// Exports
module.exports = code;